export const SORT_BY_VALUE = [
    { value: "first_name", label: "First Name" },
    { value: "last_name", label: "Last Name" },
    { value: "last_contacted_at", label: "Last Contacted" },
    { value: "updated_at", label: "Last Updated" },
    { value: "inserted_at", label: "Last Created" },
    { value: "channel", label: "Channel" }
];
